/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreAppConfigs } from '@core/configs/app.configs';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { UtenteStatusEnum } from '@models';
import { UtenteService } from '@shared/services/utente.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-pages-gestione-utente-richiesta-profilo',
    templateUrl: './richiesta-profilo.component.html',
})
export class PagesGestioneUtenteRichiestaProfiloComponent implements OnInit {
    
    public appName = CoreAppConfigs.NAME_DESKTOP;
    public datalist: any;
    public formGroup: FormGroup;
    public oldStatus: number;

    constructor(
        private utenteService: UtenteService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.formGroup = this.utenteService.generateFormUtente(this.route.snapshot.data['additionalInformation'].utenteSession);
        this.oldStatus = this.formGroup.controls['status'].value;
        this.formGroup.controls['status'].setValue(UtenteStatusEnum.WAITING);
        this.formGroup.controls['codiceFiscale'].disable();
    }

    public submitForm() {
        if (this.formGroup.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        }
        if(this.oldStatus === UtenteStatusEnum.REJECTED) {
            this.utenteService.updateRichiestaProfilo(this.formGroup.getRawValue()).subscribe(response => {
                this.utilsService.genericResponse204NoContent(response);
                this.router.navigate(['/private/gestione-utente/attesa-profilo']);
            });
        } else {
            this.utenteService.richiestaProfilo(this.formGroup.getRawValue()).subscribe(response => {
                this.utilsService.genericResponse204NoContent(response);
                this.router.navigate(['/private/gestione-utente/attesa-profilo']);
            });
        }
    }

}
